import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as action from '../../../store/actions/profileActions';
import { Chip } from '@material-ui/core';
import '../../../assets/css/style.css';

const ProfileInterestChip = ({ name }) => {
    const [chipStyles, setChipStyles] = useState({ margin: '5px' });
    const profile = useSelector(state => state.profile.profile);
    const userProfile = useSelector(state => state.profile.userProfile);
    const dispatch = useDispatch();
    
    const handleClick = (name) => {
        if (userProfile !== null) {
            if (profile.interests.find(x => x.interestName === name) === undefined) {
                dispatch(action.addProfileInterests({ profileId: userProfile.profileId, interestName: name }))
                    .then(() => {
                        setChipStyles({ margin: '5px', backgroundColor: '#41004C', color: '#fff' });
                    });
            }
            else {
                var currentInterest = userProfile.interests.find(x => x.interestName === name);
                dispatch(action.removeProfileInterests(currentInterest.interestId))
                    .then(() => {
                        setChipStyles({ margin: '5px' });
                    });
            }
        } else {
            if (profile.interests.find(x => x.interestName === name) === undefined) {
                dispatch(action.collectProfileData({...profile, interests: [...profile.interests, {interestName: name}]}));
                setChipStyles({ margin: '5px', backgroundColor: '#41004C', color: '#fff' });
            }
            else{
                dispatch(action.collectProfileData({...profile, interests: [...profile.interests.filter(x => x.interestName !== name)]}));
                setChipStyles({ margin: '5px' });
            }
        }
        
    }

    useEffect(() => {
        if (userProfile != null) {
            if (userProfile.interests.find(x => x.interestName === name) !== undefined) {
                setChipStyles({ margin: '5px', backgroundColor: '#41004C', color: '#fff' });
            }
            else{
                setChipStyles({ margin: '5px' });
            }
        } else {
            if (profile.interests.find(x => x.interestName === name) !== undefined && profile != null) {
                setChipStyles({ margin: '5px', backgroundColor: '#41004C', color: '#fff' });
            }
            else{
                setChipStyles({ margin: '5px' });
            }
        }
        
    }, []);

    return (
        <Chip label={name} variant="outlined" style={chipStyles} clickable onClick={() => handleClick(name)} />
    );
};

export default ProfileInterestChip;